import React from "react";

export const boltFilled = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.493 3.659C13.5277 3.39545 13.4774 3.12769 13.3496 2.89464C13.2217 2.66158 13.0229 2.47535 12.782 2.363C12.5342 2.24673 12.254 2.21904 11.9883 2.28457C11.7225 2.3501 11.4873 2.50486 11.322 2.723L3.51799 12.736C3.37634 12.9184 3.28669 13.1357 3.25852 13.3649C3.23035 13.5942 3.26472 13.8267 3.35799 14.038C3.52999 14.431 3.92799 14.779 4.47399 14.779H11.156L10.506 20.341C10.4713 20.6046 10.5215 20.8723 10.6494 21.1054C10.7772 21.3384 10.9761 21.5246 11.217 21.637C11.4648 21.7533 11.745 21.781 12.0107 21.7154C12.2765 21.6499 12.5117 21.4951 12.677 21.277L20.48 11.264C20.6216 11.0816 20.7113 10.8643 20.7395 10.6351C20.7676 10.4058 20.7333 10.1733 20.64 9.962C20.5465 9.74308 20.3911 9.55629 20.1928 9.42462C19.9945 9.29296 19.762 9.22218 19.524 9.221H12.842L13.493 3.659Z"
        fill="currentColor"
      />
    </svg>
  );
};
